import React from "react";

import SmartImage from "../../../components/SmartImage";

const initialOf = (name) => String(name || "").trim().slice(0, 1).toUpperCase();

const Glyph = ({ name }) =>
  initialOf(name) ? (
    <span aria-hidden="true">{initialOf(name)}</span>
  ) : (
    <span aria-hidden="true" className="rv-avatar-star">
      ★
    </span>
  );

const TargetIdentity = ({ name, imageUrl, size = 46 }) => (
  <span className="rv-avatar" style={{ "--rv-avatar-size": `${size}px` }}>
    {imageUrl ? (
      <SmartImage
        src={imageUrl}
        alt=""
        width="100%"
        height="100%"
        fallback={<Glyph name={name} />}
      />
    ) : (
      <Glyph name={name} />
    )}
  </span>
);

export default TargetIdentity;
